import React from "react";
import { toast } from "react-toastify";
import {
    Breadcrumb,
    BreadcrumbItem,
    Button,
    Card,
    CardBody,
    CardHeader,
    FormGroup,
    Input,
    Label,
    Spinner
} from "reactstrap";
import SparePartService from "../../services/SparePartService";

class SparePartSubGroupDetails extends React.Component {
    constructor(props) {
        super(props);

        const allGroups = props.location.state?.allGroups || [];
        const subGroup = props.location.state?.subGroup || null;
        const isEdit = !!subGroup;

        this.state = {
            loading: false,
            isEdit,
            id: subGroup?.id || null,
            name: subGroup?.name || "",
            shortName: subGroup?.shortName || "",
            code: subGroup?.code || "",
            groupId: subGroup?.sparePartGroupID || props.location.state.selectedGroup || null,
            allGroups,
            errors: {},
            saving: false,
        };

        this.SparePartService = new SparePartService();
    }

    validate() {
        const { name, shortName, code, groupId } = this.state;
        const errors = {};
        if (!name.trim()) {
            errors.name = "Name is required";
        }
        if (!shortName.trim()) {
            errors.shortName = "Short Name is required";
        }
        if (!code.trim()) {
            errors.code = "Code is required";
        }
        if (!groupId) {
            errors.groupId = "Group is required";
        }
        this.setState({ errors });
        return Object.keys(errors).length === 0;
    }

    handleCancel() {
        this.props.history.push('/sparepart/subgroups');
    }

    handleSave() {
        if (!this.validate()) {
            return;
        }

        const { id, name, shortName, code, groupId } = this.state;
        const payload = { id, name: name.trim(), shortName: shortName.trim(), code: code.trim(), sparePartGroupID: parseInt(groupId, 10) };
        this.setState({ saving: true });
        this.SparePartService.saveSubGroup(payload)
            .then(() => {
                toast.success("Saved successfully");
                this.props.history.push("/sparepart/subgroups");
            })
            .catch((err) => {
                const message =
                    err.response?.data?.Message || "Failed to save";
                toast.error(message);
            }).finally(() => {
                this.setState({ saving: false });
            });
    };

    render() {
        const { isEdit, name, shortName, code, groupId, allGroups, errors, saving } = this.state;

        return (
            <>
                <Breadcrumb tag="nav" listTag="div">
                    <BreadcrumbItem tag="a" href="javascript:void(0)"
                        onClick={() => this.props.history.push('/')}>Home</BreadcrumbItem>
                    <BreadcrumbItem tag="a" href="javascript:void(0)"
                        onClick={() => this.props.history.push('/sparepart/groups')}>Spare Parts Sub Groups</BreadcrumbItem>
                    <BreadcrumbItem active tag="span">Spare Parts Sub Group Details</BreadcrumbItem>
                </Breadcrumb>

                <Card>
                    <CardHeader>
                        {isEdit ? "Edit Group" : "Add Group"}
                    </CardHeader>

                    <CardBody>

                        <FormGroup>
                            <Label>Name</Label>
                            <Input
                                value={name}
                                onChange={(e) => this.setState({ name: e.target.value })}
                            />
                            {errors.name && <div className="text-danger">{errors.name}</div>}
                        </FormGroup>

                        <FormGroup>
                            <Label>Group</Label>

                            <Input type={"select"}
                                value={groupId}
                                onChange={(e) => this.setState({ groupId: e.target.value })}
                            >
                                {allGroups.map(group => (
                                    <option key={group.id} value={group.id}>{group.name}</option>
                                ))}
                            </Input>
                            {errors.groupId && <div className="text-danger">{errors.groupId}</div>}
                        </FormGroup>

                        <FormGroup>
                            <Label>Short Name</Label>
                            <Input
                                value={shortName}
                                onChange={(e) => this.setState({ shortName: e.target.value })}
                                maxLength={10}
                            />
                            {errors.shortName && <div className="text-danger">{errors.shortName}</div>}
                        </FormGroup>

                        <FormGroup>
                            <Label>Code</Label>
                            <Input
                                value={code}
                                onChange={(e) => this.setState({ code: e.target.value })}
                                maxLength={5}
                            />
                            {errors.code && <div className="text-danger">{errors.code}</div>}
                        </FormGroup>

                        <FormGroup>
                            <div className="pb-2 text-right">
                                <Button size="sm" color="primary" onClick={() => this.handleSave()}>
                                    {saving
                                        ? <Spinner size="sm"
                                            className={"mr-2"}
                                            style={{ color: "white" }} />
                                        : <i className="fa fa-floppy-o mr-2" />}
                                        Save
                                </Button>
                                <span>&nbsp;&nbsp;</span>
                                <Button size="sm" color="secondary" onClick={() => this.handleCancel()}>
                                    <i className="fa fa-times" />&nbsp;
                                    Cancel
                                </Button>

                            </div>
                        </FormGroup>

                    </CardBody>
                </Card ></>
        );
    }
}

export default SparePartSubGroupDetails;
